import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getBranding } from "../services/branding";
import api from "../services/api";
import "../css/footer.css";

const Footer = () => {
  const { t } = useTranslation();
  const [brand, setBrand] = useState(null);
  const [referEnabled, setReferEnabled] = useState(false);
  useEffect(() => {
    getBranding().then(setBrand);
    api.get("/referrals/status").then((r) => setReferEnabled(!!r.data.enabled)).catch(() => {});
  }, []);
  return (
    <footer className="fmart-footer">
      <div className="footer-main">

        {/* ─── Brand ─── */}
        <div className="footer-brand">
          <img src={brand?.logo_url || "/images/Logo1.png"} alt={brand?.store_name || "FMart Korea"} className="footer-logo" />
          <p className="footer-tagline">
            {t("footer.tagline")}
          </p>
          <div className="footer-socials">
            <a href="https://www.instagram.com/fmartskorea/" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="Instagram">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            <a href="https://www.facebook.com/share/18E6LHWSCe/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="Facebook">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a href="https://wa.me/821083851214" className="footer-social-btn" aria-label="WhatsApp">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* ─── Quick Links ─── */}
        <div className="footer-col">
          <h6>{t("footer.quickLinks")}</h6>
          <ul className="footer-links">
            <li><Link to="/">{t("nav.home")}</Link></li>
            <li><Link to="/shop">{t("nav.shop")}</Link></li>
            <li><Link to="/about">{t("nav.aboutUs")}</Link></li>
            <li><Link to="/contact">{t("nav.contact")}</Link></li>
            <li><Link to="/cart">{t("nav.cart")}</Link></li>
            {referEnabled && <li><Link to="/refer">{t("footer.referEarn")}</Link></li>}
          </ul>
        </div>

        {/* ─── Policies ─── */}
        <div className="footer-col">
          <h6>{t("footer.policies")}</h6>
          <ul className="footer-links">
            <li><Link to="/privacy-policy">{t("footer.privacyPolicy")}</Link></li>
            <li><Link to="/return-policy">{t("footer.returnPolicy")}</Link></li>
            <li><Link to="/my-orders">{t("footer.trackOrder")}</Link></li>
          </ul>
        </div>

        {/* ─── Contact ─── */}
        <div className="footer-col">
          <h6>{t("footer.contact")}</h6>
          <div className="footer-contact-item">
            <div className="footer-contact-icon">📞</div>
            <div className="footer-contact-text">
              <strong>{t("footer.phoneWhatsApp")}</strong>
              {brand?.support_phone || "+82-10-8385-1214"}
            </div>
          </div>
          <div className="footer-contact-item">
            <div className="footer-contact-icon">✉️</div>
            <div className="footer-contact-text">
              <strong>{t("footer.email")}</strong>
              {brand?.support_email || "admin@fmartskorea.com"}
            </div>
          </div>
          <div className="footer-contact-item">
            <div className="footer-contact-icon">🕐</div>
            <div className="footer-contact-text">
              <strong>{t("footer.hours")}</strong>
              {t("footer.hoursValue")}
            </div>
          </div>
        </div>
      </div>

      {/* ─── Bottom: business registration + copyright, one continuous bar ───
          Two rows of the same panel (single background, single top border)
          rather than two separate boxes stacked on each other. */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">

          {/* Legal / business registration (required for Korean e-commerce) */}
          <div className="footer-legal">
            <span className="footer-legal-name">{t("footer.legal.companyName")}</span>
            <dl className="footer-legal-grid">
              <div className="footer-legal-item">
                <dt>{t("footer.legal.representative")}</dt>
                <dd>{t("footer.legal.representativeValue")}</dd>
              </div>
              <div className="footer-legal-item">
                <dt>{t("footer.legal.brn")}</dt>
                <dd>549-29-01354</dd>
              </div>
              <div className="footer-legal-item">
                <dt>{t("footer.legal.ecommerceReg")}</dt>
                <dd>{t("footer.legal.ecommerceRegValue")}</dd>
              </div>
              <div className="footer-legal-item">
                <dt>{t("footer.legal.tel")}</dt>
                <dd><a href="tel:+821083851214">+82-10-8385-1214</a></dd>
              </div>
              <div className="footer-legal-item">
                <dt>{t("footer.legal.email")}</dt>
                <dd><a href="mailto:admin@fmartskorea.com">admin@fmartskorea.com</a></dd>
              </div>
              <div className="footer-legal-item footer-legal-item-wide">
                <dt>{t("footer.legal.address")}</dt>
                <dd>{t("footer.legal.addressValue")}</dd>
              </div>
            </dl>
          </div>

          <div className="footer-divider" />

          {/* Copyright */}
          <div className="footer-copyright-row">
            <span className="footer-bottom-text">
              {t("footer.copyright", {
                year: new Date().getFullYear(),
                name: brand?.store_name || "패밀리월드마트 – Family World Mart Korea",
              })}
            </span>
            <div className="footer-bottom-links">
              <Link to="/privacy-policy">{t("footer.privacy")}</Link>
              <Link to="/return-policy">{t("footer.returns")}</Link>
              <Link to="/contact">{t("footer.support")}</Link>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;